import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_ERROR,
  AUTH_CHECK,
} from 'react-admin';
import { Mixpanel } from './Mixpanel';

export default (type, params) => {
  if (type === AUTH_LOGIN) {
    const email = params['username'];
    const va = RegExp('console.admin*');
    const whitelist = [
      'anthony@gridwise.io',
      'brian@gridwise.io',
      'ryan@gridwise.io',
      'jeremy@gridwise.io',
      'chris@gridwise.io',
      'junda@gridwise.io',
      'nishant@gridwise.io',
      'anthcor@gmail.com',
    ];
    if (whitelist.indexOf(email) < 0 && !va.test(email)) {
      throw new Error('Unauthorized');
    }
    const password = params['password'];
    //const url='https://faregrab-staging.herokuapp.com/v1/api'
    //https://gridwise.herokuapp.com/v1/api
    let url = '';
    if (process.env.NODE_ENV === 'production') {
      url = process.env.REACT_APP_PROD_API_URL;
    } else {
      url = process.env.REACT_APP_STAGING_API_URL;
    }
    const request = new Request(url + '/authentication', {
      method: 'POST',
      body: JSON.stringify({ email: email, password: password }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });
    return fetch(request)
      .then(async response => {
        const responseJson = await response.json();
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        Mixpanel.people.set({ $email: responseJson.user.email });
        Mixpanel.identify(responseJson.user.id);
        Mixpanel.track('logged in', undefined, () => {});
        return responseJson;
      })
      .then(response => {
        localStorage.setItem('token', response['auth_token']);
        return Promise.resolve();
      });
  }

  if (type === AUTH_LOGOUT) {
    localStorage.removeItem('token');
    return Promise.resolve();
  }

  if (type === AUTH_ERROR) {
    const { status } = params;
    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      return Promise.reject();
    }
    return Promise.resolve();
  }

  if (type === AUTH_CHECK) {
    const { resource } = params;
    if (resource === 'notes') {
      return localStorage.getItem('token')
        ? Promise.resolve()
        : Promise.reject();
    } else if (resource === 'markets') {
      return localStorage.getItem('token')
        ? Promise.resolve()
        : Promise.reject();
    } else if (resource === 'events') {
      return localStorage.getItem('token')
        ? Promise.resolve()
        : Promise.reject();
    } else {
      return localStorage.getItem('token')
        ? Promise.resolve()
        : Promise.reject();
    }
  }

  return Promise.reject('Unkown method');
};



// WEBPACK FOOTER //
// ./src/authProvider.js